import React, { useEffect, useState } from 'react';
import * as S from '../SrpCardMainBlock/SrpCardMainBlock.styles';
import { useSelector } from 'react-redux';
import Srpcard from '../Srpcard/Srpcard';
import SrpActiveCard from '../SrpActiveCard/SrpActiveCard';
import { useDispatch } from 'react-redux';
import { updateRTCView, updateSelectedBus } from './../../../../containers/SRP/redux/actions';
import EndOfBuses from './../../../StoriesTestPage/SrpPage/EndOfBusesBox/EndOfBuses'
import { scrollEletoView } from './../../../../containers/Common/Utils';
import { fetchSRPGoSafeBanner } from './../../../../containers/SRP/redux/thunks';
import { srpGoSafeBannerSelector, srpRouteIdSelector } from './../../../../containers/SRP/redux/selectors';
import { IUserStoreState, userSelector } from '@stencil/user-reducer';
import GoTribeBanner from './../../../../components/GoTribe/Banner/Banner';
import { callGoTribeAPI } from './../../../../containers/Common/Utils'
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, ctaHelper, countRtcBuses } from '../../../../utils/ctaHelper'
import { CTA_TYPE, pushOmniEvents } from '../../../../../shared/utils/PushEvents/Omniture/utils'
import { commonSelector, routeStateSelector } from '../../../../containers/Common/redux/selectors';
import { userLoyaltyInfo } from '../../../../containers/Home/redux/selectors';
import AdBanner from '../../../../components/AdBanner/AdBanner';

const SrpCardMainBlock = props => {
  const [selectedSeatCopy, setSelectedSeatCopy] = useState({})
  const GOTRIBE_POSITION = 4;
  const dispatch = useDispatch();
  const srpGoSafeBanner = useSelector(srpGoSafeBannerSelector);
  const routeId = useSelector(srpRouteIdSelector);
  const { availableBusesViewData, rtcBusesViewData, soldOutBusesViewData, rtcView, openSeatLayout, selectedSeatLayoutData, busData } = props;
  const isPrivateBusesAvailable = availableBusesViewData && availableBusesViewData.length;
  const commonData = useSelector(commonSelector);
  const { src, dest, doj, dojObj} = commonData

  const userDetails = useSelector(userSelector) as IUserStoreState;
  const {userInfo, loyaltyInfo={}} = userDetails;
  const isLoggedIn = !!userDetails?.isLoggedIn;
  const [goTribeData, setGoTribeData] = useState({});
  const routeStates = useSelector(routeStateSelector)
  const userLoyalty = useSelector(userLoyaltyInfo)
  const userTier = userLoyalty?.userLoyaltyInfo?.user_tier === undefined ? '' : `${userLoyalty?.userLoyaltyInfo?.user_tier}`
  useEffect(() => {
    if (isLoggedIn) {
      fetchGoTribeData();
    }
  }, [isLoggedIn])

  async function fetchGoTribeData() {
    try {
      const { data } = await callGoTribeAPI('gotribe_bus_srp_dweb');
      if (data && !data.slots) {
        throw new Error('srp page go tribe api returned wrong response');
      }
      if (!data.slots.gotribe_bus_srp_dweb || !data.slots.gotribe_bus_srp_dweb.length) {
        return;
      }
      const goTribeData = data.slots.gotribe_bus_srp_dweb[0];
      setGoTribeData(goTribeData)
    } catch (err) {
      console.log(err);
    }
  }

  function openSelectedBusView(routeId) {
    if (isPrivateBusesAvailable) {
      for (const i in availableBusesViewData) {

        if (availableBusesViewData.hasOwnProperty(i) && availableBusesViewData[i].fh === routeId) {
          dispatch(updateSelectedBus(availableBusesViewData[i].bid));
          return;
        }
      }
      for (const i in rtcBusesViewData) {
        const availableBusesViewData = rtcBusesViewData[i].availableBusesViewData
        for (const j in availableBusesViewData) {
          if (availableBusesViewData.hasOwnProperty(j) && availableBusesViewData[j].fh === routeId) {
            dispatch(updateSelectedBus(availableBusesViewData[j].bid));
            dispatch(updateRTCView(rtcBusesViewData[i].opid));
            return;
          }
        }
      }
    }
  }

  useEffect(() => {
    openSelectedBusView(routeId);
    if (!isPrivateBusesAvailable && rtcBusesViewData && rtcBusesViewData.length && rtcBusesViewData[0].availableBusCount) {
      dispatch(updateRTCView(rtcBusesViewData[0].opid));

    }
    dispatch(fetchSRPGoSafeBanner())
    const idOfElToScrollTo = "#srpCardLayout";

    //     scrollEletoView(idOfElToScrollTo,{
    //      behavior: 'smooth',block:'start'
    // });

    return () => {
      dispatch(updateRTCView(''));
    }
  }, [])

  const isGoTribeDataPresent = goTribeData && Object.keys(goTribeData).length ? true : false;
  const setSeatSelectCopyData = (data) => {
    let selectSeatData = {...selectedSeatCopy, ...data}
    setSelectedSeatCopy(selectSeatData)
  }

  return (
    <S.SrpcardOuterWrapDiv>
      {rtcBusesViewData &&
        rtcBusesViewData.map(function (rtcOperator, index) {
          return (
            <React.Fragment key={rtcOperator.opid + rtcOperator.name + index}>
              {rtcOperator.availableBusCount ? <Srpcard
                key={rtcOperator.opid + rtcOperator.name}
                operator={rtcOperator}
                onClick={(opid: string) => {
                  if (opid) {
                    opid = opid === rtcView ? '' : opid;
                    dispatch(updateRTCView(opid));
                  }
                  const eventDetails = {
                    search : {
                        searchId: `${src}_${dest}_${doj}`,
                        noOfGovtBusResults:rtcBusesViewData && `${rtcBusesViewData[index].availableBusCount}`
                     },
                    cta: ctaHelper(['RTC_Bus_Search',CTA_TYPE.BUTTON,'RTC_Bus_Search', 'RTC_SRP']),
                    booking: {
                        routeCity: `${src}-${dest}`,
                        routeState : (routeStates.srcState && routeStates.destState) ?  `${routeStates.srcState}-${routeStates.destState}` : '',
                        daysToTrip: `${calculateDaysToTrip(dojObj)}`,
                        departureDate: `${convert_yyyymmdd_to_dd_mm_dddd(doj)}`,
                    },
                    page: {
                      pageInfo: {
                        section: "funnel",
                        pageName: "funnel:domestic bus:listing",
                        pageType: "funnel",
                        lob: "domestic bus",
                        siteName: 'GI',
                        platform: 'dweb',
                        flow: "direct-bus",
                        loadedComponents: '',
                        abVariant: '',
                        deviceId: "",
                        loyaltyStatus_v44:`Tier${loyaltyInfo?.status !=='INACTIVE' ? loyaltyInfo?.currentTier?.tierNumber || '' : '0'}_${loyaltyInfo?.status || ''}`                      },
                    },
                    account: {
                      accountInfo: {
                        custID: userInfo?.userid ? `${userInfo?.userid}` : '',
                        loginStatus:  isLoggedIn? "Logged-In" : "Guest",
                        goCash: userDetails?userDetails.gocashInfo ? `${userDetails?.gocashInfo?.data?.t_amt}` : "":'',
                        loyaltyStatus: userTier,
                        "hydraSegment": "",
                      },
                    },
                  };
                  !rtcOperator.active && pushOmniEvents({ eventName: 'ShowBuses', details: eventDetails })
                }}
              ></Srpcard> : null}

              {rtcOperator.opid === rtcView
                ? rtcOperator.availableBusesViewData.map(function (bus, index) {
                  if (!isPrivateBusesAvailable && srpGoSafeBanner && srpGoSafeBanner.banner_content && srpGoSafeBanner.banner_content.json_value && (srpGoSafeBanner.banner_content.json_value.position === index + 1 || ((srpGoSafeBanner.banner_content.json_value.position >= rtcOperator.availableBusesViewData.length) && rtcOperator.availableBusesViewData.length - 1 == index))) {
                    let ele = <React.Fragment key={bus.fh + "banner"}>
                      <span key={bus.fh + "banner"}>
                        {injectGoSafeBanner(srpGoSafeBanner)}
                      </span>

                      <SrpActiveCard key={bus.fh + index} bus={bus} openSeatLayout={openSeatLayout} selectedSeatLayoutData={selectedSeatLayoutData} index={index} setSelectedSeatCopy={(data)=> setSeatSelectCopyData(data)} selectedSeatCopy={selectedSeatCopy} isRTC={true}></SrpActiveCard>

                    </React.Fragment>
                    return ele;
                  }
                  return <SrpActiveCard key={bus.fh + index} bus={bus} openSeatLayout={openSeatLayout} selectedSeatLayoutData={selectedSeatLayoutData} setSelectedSeatCopy={(data)=> setSeatSelectCopyData(data)} selectedSeatCopy={selectedSeatCopy}  isRTC={true}/>;
                })
                : null}
              {rtcOperator.opid === rtcView
                ? rtcOperator.soldOutBusesViewData.map(function (bus, index) {
                  return <SrpActiveCard key={bus.fh + index} bus={bus} index={index} setSelectedSeatCopy={(data)=> setSeatSelectCopyData(data)} selectedSeatCopy={selectedSeatCopy} isRTC={true} />;
                })
                : null}
              {rtcOperator.opid === rtcView && rtcOperator.availableBusCount ?
                <EndOfBuses operatorName={rtcOperator.name} cb={() => {
                  const idOfElToScrollTo = `#srpCardLayout`;
                  scrollEletoView(idOfElToScrollTo, {
                    behavior: 'smooth', block: 'start'
                  })

                  dispatch(updateRTCView(''));

                }} ></EndOfBuses>
                : null}
            </React.Fragment>
          );
        })}
      {availableBusesViewData &&
        availableBusesViewData.map(function (bus, index) {
          if (srpGoSafeBanner && srpGoSafeBanner.banner_content && srpGoSafeBanner.banner_content.json_value && (srpGoSafeBanner.banner_content.json_value.position === index + 1 || ((srpGoSafeBanner.banner_content.json_value.position >= availableBusesViewData.length) && availableBusesViewData.length - 1 == index))) {

            let ele = <React.Fragment key={bus.fh + "banner"}>
              <span key={bus.fh + "banner"}>
                {injectGoSafeBanner(srpGoSafeBanner)}
              </span>

              <SrpActiveCard key={bus.fh} bus={bus} openSeatLayout={openSeatLayout} selectedSeatLayoutData={selectedSeatLayoutData} index={index} setSelectedSeatCopy={(data)=> setSeatSelectCopyData(data)} selectedSeatCopy={selectedSeatCopy} ></SrpActiveCard>
              {index === 3 && <div><AdBanner cid="QlVTI0xJU1RJTkcjQkFOTkVS" position="listing" /></div>}
            </React.Fragment>
            return ele;
          }
          if (isGoTribeDataPresent && (index + 1 == GOTRIBE_POSITION || ((GOTRIBE_POSITION >= availableBusesViewData.length) && availableBusesViewData.length - 1 == index))) {

            let ele = <React.Fragment key={bus.fh + "gotribeBannersrp"}>
              <span style={{ marginTop: '0.8rem' }}>
                <GoTribeBanner {...goTribeData}></GoTribeBanner>

              </span>

              <SrpActiveCard key={bus.fh} bus={bus} openSeatLayout={openSeatLayout} selectedSeatLayoutData={selectedSeatLayoutData} index={index} setSelectedSeatCopy={(data)=> setSeatSelectCopyData(data)} selectedSeatCopy={selectedSeatCopy} ></SrpActiveCard>
              {index === 3 &&  <div ><AdBanner cid="QlVTI0xJU1RJTkcjQkFOTkVS" position="listing" /></div>}
            </React.Fragment>
            return ele;
          }
          return( <>
          <SrpActiveCard is_bo_ads={props.is_bo_ads} key={bus.fh} bus={bus} openSeatLayout={openSeatLayout} selectedSeatLayoutData={selectedSeatLayoutData} index={index} setSelectedSeatCopy={(data)=> setSeatSelectCopyData(data)} selectedSeatCopy={selectedSeatCopy}
          />
           {index === 3 &&  <div ><AdBanner cid="QlVTI0xJU1RJTkcjQkFOTkVS" position="listing" /></div>}
          </>)
        })}
      {soldOutBusesViewData &&
        soldOutBusesViewData.map(function (bus, index) {
          return <SrpActiveCard key={bus.fh} bus={bus} index={index} />;
        })}
    </S.SrpcardOuterWrapDiv>
  );
};

export default SrpCardMainBlock;

const injectGoSafeBanner = (srpGoSafeBanner) => {
  return (
    <span>
      <img src={srpGoSafeBanner.banner_content.json_value.img_url} alt="" style={{ width: "100%", marginTop: "10px", cursor: "pointer" }} onClick={() => {
        if (srpGoSafeBanner.cta_url) {
          window.open(srpGoSafeBanner.cta_url)
        }
      }}></img>
    </span>
  )
}